module.exports = __webpack_public_path__ + "img/image15-1.fdd98fe2.png";